import Cookies from 'js-cookie';
import { COOKIE_NAME } from '../../modules/core/constants/values';

export function getCampaignInfo() {
  let campaignInfo = {};
  const campaignInfoCookie = Cookies.get(COOKIE_NAME);

  if (campaignInfoCookie) campaignInfo = JSON.parse(atob(campaignInfoCookie));

  return campaignInfo;
}

export function getBrowserResolution() {
  const win = window;
  const doc = document;
  const docElem = doc.documentElement;
  const body = doc.getElementsByTagName('body')[0];
  const x = win.innerWidth || docElem.clientWidth || body.clientWidth;
  const y = win.innerHeight || docElem.clientHeight || body.clientHeight;
  return `${x} x ${y}`;
}

export function getBrowser() {
  let currentBrowser = 'Not known';
  if (window.navigator.userAgent.indexOf('Chrome') !== -1) {
    currentBrowser = 'Google Chrome';
  } else if (window.navigator.userAgent.indexOf('Firefox') !== -1) {
    currentBrowser = 'Mozilla Firefox';
  } else if (window.navigator.userAgent.indexOf('MSIE') !== -1) {
    currentBrowser = 'Internet Exployer';
  } else if (window.navigator.userAgent.indexOf('Edge') !== -1) {
    currentBrowser = 'Edge';
  } else if (window.navigator.userAgent.indexOf('Safari') !== -1) {
    currentBrowser = 'Safari';
  } else if (window.navigator.userAgent.indexOf('Opera') !== -1) {
    currentBrowser = 'Opera';
  } else {
    console.log('Others');
  }

  return currentBrowser;
}
